//
// The assignment types consists of:
// - inspection types
// - review types
//
define(function(){
	const GenericCollection = require('civicsBase/generic_collection');
	const ASSIGNMENT_TYPES_DESCRIPTION_MAX_DISPLAY_LENGTH = 50;

	var assignmentTypeParse = function (data) {
		// loop thru the data for a given dataType
		for (i = 0; i < data.length; i++) {
	        var computedDescription =
	            Handlebars.helpers['global:computedDescription'](data[i].portalDescription, data[i].description);
	        data[i].computedDescription = computedDescription;
	        data[i].computedDescriptionShort =
	            Handlebars.helpers['global:limitLength'](computedDescription, ASSIGNMENT_TYPES_DESCRIPTION_MAX_DISPLAY_LENGTH);
		}
		return data;
	};

	var urlParms = '?Filter=[{Property:showInPortal,value:true}]&isExpired=false&isEffective=true';

	return GenericCollection.extend({
		dataTypeContext : [{
			type: 'building.Inspection',
			url: 'cdr/inspectiontypes/Building' + urlParms,
			collectionParse: assignmentTypeParse
		}, {
			type: 'building.Review',
			url: 'cdr/reviewtypes/Building' + urlParms,
			collectionParse: assignmentTypeParse
		}, {
			type: 'businessLicense.Inspection',
			url: 'cdr/inspectiontypes/BusinessLicense' + urlParms,
			collectionParse: assignmentTypeParse
		}, {
			type: 'businessLicense.Review',
			url: 'cdr/reviewtypes/BusinessLicense' + urlParms,
			collectionParse: assignmentTypeParse
		}, {
			type: 'codeEnforcement.Inspection',
			url: 'cdr/inspectiontypes/CodeEnforcement' + urlParms,
			collectionParse: assignmentTypeParse
		}, {
			type: 'codeEnforcement.Review',
			url: 'cdr/reviewtypes/CodeEnforcement' + urlParms,
			collectionParse: assignmentTypeParse
		}, {
			type: 'planning.Inspection',
			url: 'cdr/inspectiontypes/Planning' + urlParms,
			collectionParse: assignmentTypeParse
		}, {
			type: 'planning.Review',
			url: 'cdr/reviewtypes/Planning' + urlParms,
			collectionParse: assignmentTypeParse
		}, {
			type: 'project.Inspection',
			url: 'cdr/inspectiontypes/Project' + urlParms,
			collectionParse: assignmentTypeParse
		}, {
			type: 'project.Review',
			url: 'cdr/reviewtypes/Project' + urlParms,
			collectionParse: assignmentTypeParse
		}, {
			type: 'tradeLicense.Inspection',
			url: 'cdr/inspectiontypes/TradeLicense' + urlParms,
			collectionParse: assignmentTypeParse
		}, {
			type: 'tradeLicense.Review',
			url: 'cdr/reviewtypes/TradeLicense' + urlParms,
			collectionParse: assignmentTypeParse
		}, {
			type: 'use.Inspection',
			url: 'cdr/inspectiontypes/Use' + urlParms,
			collectionParse: assignmentTypeParse
		}, {
			type: 'use.Review',
			url: 'cdr/reviewtypes/Use' + urlParms,
			collectionParse: assignmentTypeParse
		}]
	});
});
